import React, { useState } from 'react';
import { BLOCKS } from '@contentful/rich-text-types';
import _ from 'lodash';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import './index.scss';

const TableOfContents = ({ content }) => {
  const [isActive, setIsActive] = useState(false);
  const [selectedItem] = useState('In this article');
  //const [ setIsSelectedItem] = useState('In this article');

  const onListItemClick = (e, node) => {
    e.preventDefault();
    let url = node?.content[0]?.content[1]?.data?.uri?.slice(1);
    if (typeof window !== 'undefined') {
      window.history.pushState(
        {},
        `condition-treatment${url}`,
        `${window.location.pathname}${window.location.search}#${url}`
      );
    }
    document
      .getElementById(url)
      .scrollIntoView({ behavior: 'smooth', block: 'start' });
    _.setFocusWithoutReload(`#${node?.content[0]?.content[1]?.data?.uri}`, 'a');
    //setIsSelectedItem(e.target.textContent);
    setIsActive(!isActive);
  };

  const renderOption = {
    renderNode: {
      [BLOCKS.LIST_ITEM]: node => {
        return (
          <li
            onClick={e => onListItemClick(e, node)}
            className="listItemMobile"
          >
            {node?.content[0].content.length > 0 && (
              <a href={node?.content[0]?.content[1]?.data?.uri}>
                {node?.content[0]?.content[1]?.content[0]?.value}
              </a>
            )}
          </li>
        );
      }
    }
  };
  return (
    <div className="anchorLinks">
      <div className="desktop-only">
        <div className="lists">
          <div className="linksTitle">In this article:</div>
          {documentToReactComponents(JSON.parse(content).json)}
        </div>
      </div>
      <div className="mobile-only">
        <div className="dropdownLists">
          <div
            onClick={() => {
              setIsActive(!isActive);
            }}
            className="dropdownBtn themeFocus"
            tabIndex={0}
            onKeyDown={e => {
              if (e.key === 'Enter') setIsActive(!isActive);
            }}
          >
            <span className="listsIcon">
              <img
                src="/content/images/icons/union.svg"
                width="14"
                height="20"
              />
            </span>
            <label>{selectedItem}</label>
            <span className={isActive ? 'upArrow' : 'downArrow'}>
              <img
                src="/content/images/icons/dropDownArrow.svg"
                width="24"
                height="24"
              />
            </span>
          </div>
          <div
            className="dropdownContent"
            style={{ display: isActive ? 'block' : 'none' }}
          >
            {documentToReactComponents(JSON.parse(content).json, renderOption)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableOfContents;
